import React from 'react';

import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';

import * as d3 from 'd3';

import TimePlot from '../containers/TimePlot';
import { months } from '../constants.js';

const styles = (theme) => ({
  cardHeader: {
    //backgroundColor: '#165469',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    color: '#fff',
    padding: '5px',
    paddingLeft: '20px',
    fontFamily: 'Flanders Art Sans!important',
    textAlign: 'left',
    fontSize: '1.1em',
    fontWeight: 700,
    borderRadius: '10px',
    marginBottom: '1em',
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.9em',
    },
  },
});

function GraphContainer(props) {
  const { classes } = props;

  let oneWeekAgo = d3.timeDay.offset(props.selectedDate, -7);
  let threeDaysAgo = d3.timeDay.offset(props.selectedDate, -3);
  const weekPeriod =
    props.windowWidth >= 960
      ? (oneWeekAgo.getMonth() === props.selectedDate.getMonth()
          ? d3.timeFormat('%e -')(oneWeekAgo)
          : d3.timeFormat('%e %B -')(oneWeekAgo)) +
        ' ' +
        d3.timeFormat('%e %B')(props.selectedDate)
      : (threeDaysAgo.getMonth() === props.selectedDate.getMonth()
          ? d3.timeFormat('%e -')(threeDaysAgo)
          : d3.timeFormat('%e %B -')(threeDaysAgo)) +
        ' ' +
        d3.timeFormat('%e %B')(props.selectedDate);

  const weekTitle = 'Week van ' + weekPeriod + ' (data per uur)';
  const yearTitle =
    'Van ' +
    (props.windowWidth >= 960 ? '2014' : new Date().getFullYear() - 3) +
    ' tot ' +
    new Date().getFullYear() +
    ' (data per maand)';
  return (
    <Grid container>
      <Paper className={classes.cardHeader + ' headerText bgdarkbluegreen'}>
        <div style={{ height: '40px', lineHeight: '40px' }}>
          <div>{weekTitle}</div>
        </div>
      </Paper>
      <Grid item xs={12} container direction={'row'} spacing={1}>
        <Grid item xs={12} md={8}>
          <TimePlot
            currentTech={props.currentTech}
            currentFilter={props.currentFilter}
            currentMode={'realtime'}
            data={props.data}
            currentDateTime={props.currentDateTime}
            selectedDate={props.selectedDate}
            dataReady={props.dataReady}
            windowWidth={props.windowWidth}
            lang={props.lang}
            graphType="Production"
            graphDisplay={props.graphDisplay}
          />
          <TimePlot
            currentTech={props.currentTech}
            currentFilter={props.currentFilter}
            currentMode={'realtime'}
            data={props.data}
            currentDateTime={props.currentDateTime}
            selectedDate={props.selectedDate}
            dataReady={props.dataReady}
            windowWidth={props.windowWidth}
            lang={props.lang}
            graphType="ProductionVsDemand"
            graphDisplay={props.graphDisplay}
          />
          <TimePlot
            currentTech={props.currentTech}
            currentFilter={props.currentFilter}
            currentMode={'realtime'}
            data={props.data}
            currentDateTime={props.currentDateTime}
            selectedDate={props.selectedDate}
            dataReady={props.dataReady}
            windowWidth={props.windowWidth}
            lang={props.lang}
            graphType="CoveredDemand"
            graphDisplay={props.graphDisplay}
          />
          <TimePlot
            currentTech={props.currentTech}
            currentFilter={props.currentFilter}
            currentMode={'realtime'}
            data={props.data}
            currentDateTime={props.currentDateTime}
            selectedDate={props.selectedDate}
            dataReady={props.dataReady}
            windowWidth={props.windowWidth}
            lang={props.lang}
            graphType="DayAheadPrices"
            graphDisplay={props.graphDisplay}
          />
        </Grid>
        <Grid item xs={12} md={4} style={{ textAlign: 'left' }}>
          <p className="noTopMargin">
            In de bovenste grafieken kan u de groenestroomproductie uit
            zonnepanelen, onshore en offshore windturbines in Vlaanderen
            opvragen (klik de knoppen aan). De data worden per uur weergegeven,
            tijdens de gekozen kalenderdagen. Wijzigt u de einddatum niet, dan
            eindigt de grafiek met een voorspelling voor vandaag.
          </p>
          <p>
            U ziet ook de corresponderende elektriciteitsvraag voor Vlaanderen
            en voor welk aandeel van de vraag de geïnstalleerde zonnepanelen en
            windturbines bijdragen.
          </p>
          <p>
            De opbrengst van zonnepanelen piekt overdag, afhankelijk van het
            aanbod aan zonlicht. Windturbines kunnen dag en nacht opbrengen,
            afhankelijk van de hoeveelheid wind.
          </p>
          <p>
            De productie van zonne- en windenergie komt niet noodzakelijk
            overeen met ons elektriciteitsgebruik. Onze vraag daalt &apos;s
            nachts en in het weekend door de lagere industriële activiteit,
            terwijl het weer ook &apos;s nachts (wind) en in het weekend (wind
            en zon) voor belangrijke stroomopbrengsten kan zorgen. Om te weten
            voor welk aandeel van onze elektriciteitsvraag de zonnepanelen en
            windturbines instaan, delen we deze groenestroomproductie door de
            elektriciteitsvraag.
          </p>
        </Grid>
      </Grid>

      <Paper className={classes.cardHeader + ' headerText bgdarkbluegreen'}>
        <div style={{ height: '40px', lineHeight: '40px' }}>
          <div>{yearTitle}</div>
        </div>
      </Paper>
      <Grid item xs={12} container direction={'row'} spacing={2}>
        <Grid item xs={12} md={8}>
          <TimePlot
            currentTech={props.currentTech}
            currentFilter={props.currentFilter}
            currentMode={'historical'}
            data={props.data}
            currentDateTime={props.currentDateTime}
            selectedDate={props.selectedDate}
            dataReady={props.dataReady}
            windowWidth={props.windowWidth}
            lang={props.lang}
            graphType="InstalledCapacities"
            graphDisplay={props.graphDisplay}
            finalYear={props.finalYear}
          />
        </Grid>
        <Grid item xs={12} md={4} style={{ textAlign: 'left' }}>
          <p className="noTopMargin">
            Het geïnstalleerde vermogen aan zonnepanelen is ondertussen ongeveer
            gelijk aan het vermogen van onshore en offshore windturbines samen.
          </p>
          <p>
            Het vermogen aan offshore windturbines stijgt trapsgewijs, dat komt
            door de bouw van windparken in de Noordzee.
          </p>
        </Grid>
      </Grid>
      <Grid item xs={12} container direction={'row'} spacing={2}>
        <Grid item xs={12} md={8}>
          <TimePlot
            currentTech={props.currentTech}
            currentFilter={props.currentFilter}
            currentMode={'historical'}
            data={props.data}
            currentDateTime={props.currentDateTime}
            selectedDate={props.selectedDate}
            dataReady={props.dataReady}
            windowWidth={props.windowWidth}
            lang={props.lang}
            graphType="YearlyProduction"
            graphDisplay={props.graphDisplay}
            finalYear={props.finalYear}
          />
        </Grid>
        <Grid item xs={12} md={4} style={{ textAlign: 'left' }}>
          <p className="noTopMargin">
            Ondanks het grotere geïnstalleerde vermogen aan zonnepanelen zijn de
            maandelijkse productiepieken vergelijkbaar met die van offshore
            windturbines. We zien dat de elektriciteitsproductie door
            zonnepanelen complementair is aan de productie door windturbines.
            Terwijl de opbrengst van zonnepanelen tussen maart en september het
            hoogst is, piekt de productie door windturbines tussen september en
            maart.
          </p>
        </Grid>
      </Grid>
      <Grid item xs={12} container direction={'row'} spacing={2}>
        <Grid item xs={12} md={8}>
          <TimePlot
            currentTech={props.currentTech}
            currentFilter={props.currentFilter}
            currentMode={'historical'}
            data={props.data}
            currentDateTime={props.currentDateTime}
            selectedDate={props.selectedDate}
            dataReady={props.dataReady}
            windowWidth={props.windowWidth}
            lang={props.lang}
            graphType="YearlyProductionVsDemand"
            graphDisplay={props.graphDisplay}
            finalYear={props.finalYear}
          />
        </Grid>
        <Grid item xs={12} md={4} style={{ textAlign: 'left' }}>
          <p className="noTopMargin">
            Het elektriciteitsgebruik is sinds 2014 redelijk stabiel. Elk jaar
            zien we een gebruikspiek tijdens de wintermaanden
            (november-februari) en een lagere vraag tijdens de zomermaanden. De
            opwekking van groene stroom uit zon en wind is meer dan verdubbeld
            sinds januari 2014 (424 GWh) en december 2019 (872 GWh) dankzij
            bijkomende investeringen in zonnepanelen en windturbines.
          </p>
        </Grid>
      </Grid>
      <Grid item xs={12} container direction={'row'} spacing={2}>
        <Grid item xs={12} md={8}>
          <TimePlot
            currentTech={props.currentTech}
            currentFilter={props.currentFilter}
            currentMode={'historical'}
            data={props.data}
            currentDateTime={props.currentDateTime}
            selectedDate={props.selectedDate}
            dataReady={props.dataReady}
            windowWidth={props.windowWidth}
            lang={props.lang}
            graphType="CoveredYearlyDemand"
            graphDisplay={props.graphDisplay}
            finalYear={props.finalYear}
          />
        </Grid>
        <Grid item xs={12} md={4} style={{ textAlign: 'left' }}>
          <p className="noTopMargin">
            De rol van zonnepanelen en windturbines wordt duidelijker als we het
            aandeel in de elektriciteitsvraag visualiseren. In januari 2014 werd
            ongeveer 8% van de totale elektriciteitsvraag ingevuld door deze
            groene energiebronnen. In 2020 piekte het aandeel zelfs tot 28
            procent. Er waren ook uitzonderlijke maanden: stormachtige
            weersomstandigheden zorgden voor veel windenergie en de strikte
            lockdown tijdens de Covid-19-pandemie hield de elektriciteitsvraag
            opmerkelijk laag.
          </p>
        </Grid>
      </Grid>
    </Grid>
  );
}

GraphContainer.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(GraphContainer);
